<template>
    <div class="xfz">
        <div class="left_list">
            <div class="list_title_main">
                <div class="left">
                    荣誉展示
                </div>
                <div class="more" @click="showMore">
                    更多 >
                </div>
            </div>
            <div class="list_item " v-for="(item, index) in NewsList" :key="index" @click="showNewsDetail( item )" 
            @mouseover="hoverIndex =index" @mouseout="hoverIndex = null">
                 <div class="img_content_box">
                     <div :class="hoverIndex == index ? 'hvr-grow' : '' ">
                        <img :src="item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1"  alt="">
                        <img :src="$ImgUrl + item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1"  alt="">
                    </div>
                 </div>
                <div class="list_title" :class="hoverIndex == index ? 'activeItem' : '' ">
                    <span> {{ item.news_title}} </span>
                </div>
            </div>
        </div>
        <div class="right_paiming">
            <div class="img_box">
                <img src="../../assets/static/index/ph_bg.png" alt="">
                <div class="text">积分排行</div>
            </div>
            <div class="pm_list">

                <div class="dept_list">
                    <div class="btn_box " :class="active == 1 ? 'bg-red' : 'bg-gray' " @click="setActive(1)" >会员</div>
                    <!-- <div class="btn_box " :class="active == 2 ? 'bg-red' : 'bg-gray' " @click="setActive(2)">党支部</div> -->
                </div>

                <div class="list_box">
                    <div class="list_item hvr-forward" v-for="(item, index) in list" :key="index">
                        <div class="list_iconbox">
                            <div class="img_box" v-if="index < 3">
                                <img src="../../assets/static/index/ph_ico01.png" v-if="item.rank == 1" alt="">
                                <img src="../../assets/static/index/ph_ico02.png" v-if="item.rank == 2" alt="">
                                <img src="../../assets/static/index/ph_ico03.png" v-if="item.rank == 3" alt="">
                            </div>
                            <div class="list_iconbox" v-else>
                                {{ index + 1 }}
                            </div>
                        </div>
                        <div class="list_name">
                            {{ item.userName }}
                        </div>
                        <div class="point">
                            {{ item.integral }}
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                active: 1,
                list: [

                ], // 排名列表
                size: 6,
                cate_id: 24,
                NewsList: [], // 党员先锋展
                hoverIndex: null,
            }
        },
        mounted() {
            this.getNewsList()
            this.getUserRank()
        },
        methods: {
            // 点击组织或个人
            setActive ( num ) {
                this.active = num 
            },
            // 获取新闻列表
            async getNewsList () {
                let { cate_id, size } = this 
                let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id, pageSize: size })
                if ( res.data.code == 1 ) {
                    this.NewsList = res.data.res
                }
            },
             // 展示新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.news_id}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            },

            // 获取党员排名
            async getUserRank () {
                let res = await this.$axios.post("/lencon/pc/index/userRank", { page: 1 })
                if ( res.data.code == 1 ) {
                    this.list = res.data.data
                }
            },

            // 更多
            showMore () {
                this.$router.push({
                    path: "/moreNewsList",
                    query: {
                        cate_id: this.cate_id,
                        isSearch:0,
                        keyword: ""
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.activeItem {
    color: #2767c4 ;
    font-weight: bold;
}
.xfz {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .left_list {
        width: 800px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .list_title_main {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0;
            border-bottom: 1px solid #2767c4 ;
            margin-bottom: 20px;
            .left {
                font-size: 24px;
                color: #2767c4 ;
                font-weight: bold;
            }
            .more {
                font-size: 14px;
                color: #b3b3b3;
                cursor: pointer;
            }
        }
        .list_item {
            width: 260px;
            cursor: pointer;
            .img_content_box {
                width: 260px;
                height: 156px;
                overflow: hidden;
                img {
                    width: 260px;
                    height: 156px;
                }
            }
            .list_title {
                font-size: 16px;
                padding: 20px 5px;
                // height: 80px;
                margin-bottom: 20px;
                span {
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // display: -webkit-box;
                    // -webkit-line-clamp: 2;
                    // -webkit-box-orient: vertical;
                    @include MultipleRows(2);
                }
            }
        }
    }
    .right_paiming {
        width: 357px;
        .img_box {
            width: 100%;
            text-align: center;
            position: relative;
            left: 0;
            top: 0;
            z-index: 1;
            .text {
                width: 100%;
                text-align: center;
                position: absolute;
                left: 0;
                top: 0;
                font-size: 24px;
                font-weight: bold;
                color: #fff;
                line-height: 45px;
            }
        }
        .pm_list {
            // height: 100%;
            border: 1px solid #2767c4 ;
            border-radius: 10px;
            transform: translateY(-30px);
            .dept_list {
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 50px;
                .btn_box {
                    width: 130px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    border-radius: 15px;
                    margin: 0 10px;
                    cursor: pointer;
                }
            }
            .list_box {
                width: 100%;
                padding: 20px;
                .list_item {
                    display: flex;
                    align-items: center;
                    &:hover {
                        background-color: #2767c4 ;
                        color: #fff;
                        .point {
                            color: #fff;
                        }
                    }
                    .list_iconbox {
                        width: 35px;
                        height: 35px;
                        // display: flex;
                        // align-items: center;
                        text-align: center;
                        line-height: 35px;
                        img {
                            width: 35px;
                            height: 35px;
                        }
                    }
                    .list_name {
                        line-height: 40px;
                        flex: 1;
                        margin: 0 10px;
                        @include SingleRow;
                    }
                    .point {
                        width: 60px;
                        font-size: 16px;
                        font-weight: bold;
                        color: #2767c4 ;
                    }
                }
            }
        }
        
    }
}
</style>